import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import IndividualValidationResult from 'components/IndividualValidationResult';
import WhdStatementValidationResult from 'components/WhdStatementValidationResult';

class ValidationResultsSection extends Component {
  static propTypes = {
    validationResult: PropTypes.shape(),
    isValidatingForm: PropTypes.bool,
    isOnlineForm: PropTypes.bool,
    showWitholdingValidation: PropTypes.bool,
    accountNumber: PropTypes.string
  };

  static defaultProps = {
    validationResult: null,
    isValidatingForm: false,
    isOnlineForm: false,
    showWitholdingValidation: false,
    accountNumber: null
  };

  getFormValidityStatus() {
    const { validationResult } = this.props;

    let statusText = '';
    if (validationResult) {
      statusText = validationResult.valid ? 'Valid' : 'Invalid';
      statusText += validationResult && validationResult.result[0] && validationResult.result[0].isWithTreaty ? ' with Treaty' : '';
      statusText += validationResult && validationResult.result[0] && validationResult.result[0].isLocked ? ' & Locked' : '';
    }

    return statusText;
  }

  isValidated() {
    const { validationResult } = this.props;
    return (validationResult && validationResult.result);
  }

  render() {
    const {
      isValidatingForm,
      isOnlineForm,
      validationResult,
      showWitholdingValidation,
      accountNumber
    } = this.props;
    return (
      <div>
        <h1>Validation Results</h1>
        <div className="result-status">
          { <h2 className={ validationResult && validationResult.valid ? 'valid' : 'invalid' }> { this.getFormValidityStatus() }</h2> }
          { !this.isValidated() && <h2 className="none">Not Validated</h2> }
        </div>
        <div className="validation-result-content">
          { isValidatingForm && <div className="validating-progress" style={ { display: 'flex', flexDirection: 'column' } }>
            <p style={ { paddingBottom: '2em' } }>
              Please wait while a validation process is performing.
            </p>
            <progress className="progress" max="100" />
          </div> }
          { !isValidatingForm && this.isValidated() && <div className="validation-result-message">
            {
              [...validationResult.result].length > 1
                ? [...validationResult.result].map((x, i) => x != null && (<IndividualValidationResult
                  key={ validationResult.result[i].formId }
                  formId={ validationResult.result[i].formId }
                  customerId={ validationResult.result[i].imyCustomerId || validationResult.result[i].customerId }
                  customerName={ validationResult.result[i].customerName }
                  isOnlineForm={ isOnlineForm }
                  formType={ validationResult.result[i].formType }
                  valid={ validationResult.result[i].valid }
                  rejections={ validationResult.result[i].rejections }
                  warnings={ validationResult.result[i].warnings }
                  overrides={ validationResult.result[i].overrides }
                  isWithTreaty={ validationResult.result[i].isWithTreaty }
                  isLocked={ validationResult.result[i].isLocked }
                  accountNumber={ accountNumber }
                />))
                : <IndividualValidationResult
                  key={ validationResult.result[0].formId }
                  formId={ validationResult.result[0].formId }
                  customerId={ validationResult.result[0].imyCustomerId || validationResult.result[0].customerId }
                  customerName={ validationResult.result[0].customerName }
                  formType={ validationResult.result[0].formType }
                  isOnlineForm={ isOnlineForm }
                  valid={ validationResult.valid }
                  rejections={ validationResult.result[0].rejections }
                  warnings={ validationResult.result[0].warnings }
                  overrides={ validationResult.result[0].overrides }
                  isWithTreaty={ validationResult.result[0].isWithTreaty }
                  isLocked={ validationResult.result[0].isLocked }
                  accountNumber={ accountNumber }
                />
            }
            { showWitholdingValidation && validationResult.whdResult != null
              && <WhdStatementValidationResult
                result={ validationResult.whdResult }
              /> }
            </div> }
          { !isValidatingForm && !this.isValidated() && <div className="validation-result-message">
            <p>
              This form has not yet been validated.
              Click the &quot;{ isOnlineForm ? 'Check and Submit' : 'Validate form' }&quot; button below to receive the validation results.
            </p>
          </div> }
        </div>
      </div>
    );
  }
}

export default ValidationResultsSection;
